import React from "react";
import Box from "@mui/material/Box";
import { Paper, Stack, Typography } from "@mui/material";

// ── Helpers ───────────────────────────────────────────────────────────────────

export function healthColor(status) {
    const s = String(status ?? "").toUpperCase();
    if (["UP", "HEALTHY", "OK", "IDLE", "RUNNING", "ACTIVE", "READY", "CONNECTED"].includes(s)) return "success";
    if (["DOWN", "ERROR", "FAILED", "CLOSED", "STOPPED", "CRASHED"].includes(s))                return "error";
    return "warning";
}

// Statuts spécifiques aux workers / consommateurs RabbitMQ
export function workerStatusColor(status) {
    const s = String(status ?? "").toUpperCase();
    if (["IDLE", "RUNNING", "ACTIVE", "READY", "UP", "OK", "HEALTHY", "CONNECTED"].includes(s)) return "success";
    if (["BLOCKED", "FLOW", "BUSY", "SUSPENDED"].includes(s))                                   return "warning";
    if (["DOWN", "ERROR", "FAILED", "CLOSED", "STOPPED", "CRASHED", "UNAVAILABLE"].includes(s)) return "error";
    return "default";  // statut inconnu → gris neutre
}

export function queueState(state) {
    const s = String(state ?? "").toLowerCase();
    if (s === "running" || s === "idle") return "success";
    if (s === "down"    || s === "flow") return "error";
    return "warning";
}

export function dgStyle() {
    return {
        border: "none",
        "& .MuiDataGrid-columnHeader": {
            bgcolor: "action.hover", fontSize: "0.75rem", fontWeight: 700,
            textTransform: "uppercase", letterSpacing: "0.05em", color: "text.secondary",
        },
        "& .MuiDataGrid-columnSeparator": { display: "none" },
        "& .MuiDataGrid-cell": { alignItems: "center", display: "flex", py: "6px", borderBottom: "1px solid", borderColor: "divider", fontSize: "0.8125rem" },
        "& .MuiDataGrid-row:hover": { bgcolor: "action.hover" },
        "& .MuiDataGrid-toolbarContainer": { px: 2, pt: 1.5, gap: 1 },
        "& .MuiDataGrid-footerContainer": { borderTop: "1px solid", borderColor: "divider" },
    };
}

// ── Stat card ─────────────────────────────────────────────────────────────────
export function StatCard({ icon, label, value, color = "primary.main", sub, onClick }) {
    const clickable = !!onClick;
    return (
        <Paper
            variant="outlined"
            onClick={onClick}
            sx={{
                p: 2, borderRadius: 2, flex: 1, minWidth: 130,
                borderLeft: "4px solid", borderColor: color,
                cursor: clickable ? "pointer" : "default",
                transition: "box-shadow 0.15s, transform 0.1s",
                "&:hover": clickable ? { boxShadow: 3, transform: "translateY(-1px)" } : {},
            }}>
            <Stack direction="row" alignItems="center" gap={0.75} mb={0.5}>
                <Box sx={{ color, display: "flex" }}>{icon}</Box>
                <Typography variant="caption" color="text.secondary" fontWeight={600}>{label}</Typography>
                {clickable && (
                    <Typography variant="caption" color="text.disabled" sx={{ ml: "auto", fontSize: 10 }}>
                        ▾
                    </Typography>
                )}
            </Stack>
            <Typography variant="h5" fontWeight={800} sx={{ color, lineHeight: 1 }}>{value}</Typography>
            {sub && <Typography variant="caption" color="text.disabled" display="block" mt={0.3}>{sub}</Typography>}
        </Paper>
    );
}

